import { getImageUrl } from "src/Common/common";

// Warning banner + card list of work orders that conflict with a time-off
// window. `wos` is the array returned by
// TimeOffService.getConflictingWos(); when empty, nothing is rendered.
function ConflictedWos({ wos }) {
  if (!wos || wos.length === 0) {
    return (
      <div className="self-stretch p-3 rounded-md border border-[#F3F4F6] bg-[#F9FAFB]">
        <span className="text-[14px] font-InterRegular text-[#6B7280] leading-5">
          No scheduled work orders during this time.
        </span>
      </div>
    );
  }

  return (
    <>
      <div className="self-stretch flex items-start gap-2 p-3 rounded-lg border border-[#FEF3C7] bg-[#FFFBEB]">
        <img src={getImageUrl("/images/timeoff/warning.svg")} className="w-[16px] h-[16px]" alt="" />
        <span className="text-[12px] font-InterMedium text-[#92400E] leading-4">
          {wos.length} scheduled {wos.length === 1 ? "job" : "jobs"} will need to be reassigned.
        </span>
      </div>

      {wos.map((wo) => {
        const start = wo.startDate ? new Date(wo.startDate) : null;
        const dateLabel = start
          ? start.toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })
          : "-";
        const timeLabel = start
          ? start.toLocaleTimeString("en-US", {
              hour: "numeric",
              minute: "2-digit",
            })
          : "";
        const location = [wo.customerLocation?.city, wo.customerLocation?.state].filter(Boolean).join(", ");
        return (
          <div
            key={wo.id}
            className="self-stretch flex flex-col items-start gap-2 p-4 rounded-xl border border-[#E5E7EB] bg-white shadow-[0_1px_2px_0_rgba(0,0,0,0.05)]"
          >
            <div className="text-[14px] font-InterBold text-[#111827] leading-5" style={{ letterSpacing: "-0.055px" }}>
              {wo.number || "WO"}
              {wo.serviceType?.serviceType && ` • ${wo.serviceType.serviceType}`}
            </div>
            <div className="flex flex-col gap-1">
              <div className="text-[12px] font-InterRegular text-[#6B7280] leading-4">
                {dateLabel}
                {timeLabel && ` • ${timeLabel}`}
              </div>
              <div className="text-[12px] font-InterRegular text-[#6B7280] leading-4">
                {wo.customer?.companyName || "-"}
                {location && ` • ${location}`}
              </div>
            </div>
            <a
              href={`/work/${wo.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="self-stretch h-10 rounded-md border border-[#E5E7EB] bg-white hover:bg-[#F9FAFB] flex items-center justify-center"
            >
              <span
                className="text-center text-[12px] font-InterSemiBold text-[#374151] leading-4"
                style={{ letterSpacing: "0.035px" }}
              >
                View Work Order
              </span>
            </a>
          </div>
        );
      })}
    </>
  );
}

export default ConflictedWos;
